























import Vue from 'vue';

import WrapperCard from '@/components/atoms/WrapperCard.vue';
import ModelModalBase from '@/components/molecules/ModelModalBase.vue';

export default Vue.extend({
  name: 'ModelModal',
  components: {
    WrapperCard,
    ModelModalBase,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    closeButton: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: '500px',
    },
  },
  data() {
    return { valueBeforeUpdate: this.$props.value };
  },
  updated() {
    // モーダルが非表示から表示になったとき、モーダルの DOM の render が完了したことを通知する
    if (this.$props.value && this.$data.valueBeforeUpdate === false) {
      this.$emit('modal-rendered');
    }
    this.$data.valueBeforeUpdate = this.$props.value;
  },
  methods: {
    close() {
      this.$emit('input', false);
    },
  },
});
